import { render, staticRenderFns } from "./ProductDesignFormEditImages.vue?vue&type=template&id=ec484c2e&"
import script from "./ProductDesignFormEditImages.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormEditImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports